import { render } from "./BasicFormToolbar.vue?vue&type=template&id=3d60f14a&scoped=true"
import script from "./BasicFormToolbar.vue?vue&type=script&lang=js"
export * from "./BasicFormToolbar.vue?vue&type=script&lang=js"

import "@/components/general/css/BasicFormToolbar.css?vue&type=style&index=0&id=3d60f14a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\MAX\\Documents\\Repositorios\\gem_tpv_pwa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d60f14a"]])

export default __exports__